import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import Popup from "reactjs-popup";
import { PopupMessage, InfoPopupMessage } from "../utils/utils";
import axios from "axios";
import { clientAccess } from "../utils/index";
import "bootstrap/dist/css/bootstrap.css";
import apiUrl from "../apiUrlConstant";
import CreatableSelect from "react-select/creatable";
import DatePicker from "react-datepicker";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";
import TopHeader from "../layout/TopHeader";
import SimpleReactValidator from "simple-react-validator";
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

const YearArr = [];

for (var i = 2015; i <= 2030; i++) {
  YearArr.push(i)
}

class OutflowComponentCreate extends React.Component {



  state = {
    disableFields: false,
    LandlordGroups: [],
    clientList: [],
    redirect: false,
    assetsList: [],
    financialYearOne: '',
    financialYearTwo: '',
    url: `${apiUrl.apiUrl.url}/outflow/save-asset-wise-data`,
    id: undefined,
    formElements: [],
    filterShow: true,
    initialValues: {
      groupId: "",
      groupName: "",
      clientId: "",
      clientName: "",
      financialYearOne: '',
      financialYearTwo: '',
      bifurcationStatus: 0,
      outflow_type: "",
      sub_total: 0,
      mark_up: 0,
      sinking_fund: 0,
      total_expense: 0
    },
  };

  resetForm(values) {
    this.state.initialValues = {};
    values.groupId = "";

    this.setState({});
  }

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  componentDidMount() {
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          LandlordGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-assets-by-filter`,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          assetsList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

  }


  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/outflow/save-asset-wise-data`,

          initialValues: {
            groupId: "",
            groupName: "",
            clientId: "",
            clientName: "",
            asset_name: "",
            outflow_type: "",
            financialYearOne: "",
            financialYearTwo: "",

          },
        });
      } else {
        let self = this;
        axios.get(`${apiUrl.apiUrl.url}/outflow/fetch-outflow-data?id=${this.props.match.params.id}`).then((response) => {
          let data = response.data;
          self.setState({
            url: `${apiUrl.apiUrl.url}/outflow/update-asset-wise-data?id=${self.props.match.params.id}`,
            formElements: data.formElements,
            financialYearOne: new Date(data.postAllData.financialYearOne),
            financialYearTwo: new Date(data.postAllData.financialYearTwo),
            disableFields: true,
            filterShow: false
          });


          self.state.initialValues = {
            financialYearOne: data.postAllData.financialYearOne,
            financialYearTwo: data.postAllData.financialYearTwo,
            bifurcationStatus: data.postAllData.bifurcationStatus,
            outflow_type: data.postAllData.outflow_type,
            sub_total: data.postAllData.sub_total,
            mark_up: data.postAllData.mark_up,
            sinking_fund: data.postAllData.sinking_fund,
            total_expense: data.postAllData.total_expense,
            assetId: data.postAllData.assetId,
            assetName: data.postAllData.assetName,
            OutflowOpexType: data.otherDetailsArr.OutflowOpexType,
            OutflowSubType: data.otherDetailsArr.OutflowSubType,
            outflow: data.otherDetailsArr.outflow,
          }
          self.setState({});
        });


        // fetch(
        //   `${apiUrl.apiUrl.url}/outflow/fetch-outflow-data?id=${this.props.match.params.id}`
        // )
        //   .then((response) => {
        //     return response.json();
        //   })
        //   .then((data) => {
        //     console.log(data, "data.data");
        //     this.setState({
        //       url: `${apiUrl.apiUrl.url}/outflow/update-asset-wise-data?id=${this.props.match.params.id}`,
        //       formElements: data.formElements,
        //       financialYearOne: new Date(data.postAllData.financialYearOne),
        //       financialYearTwo: new Date(data.postAllData.financialYearTwo),
        //       disableFields: true,
        //       filterShow: false
        //     });


        //     this.state.initialValues = {
        //       financialYearOne: data.postAllData.financialYearOne,
        //       financialYearTwo: data.postAllData.financialYearTwo,
        //       bifurcationStatus: data.postAllData.bifurcationStatus,
        //       outflow_type: data.postAllData.outflow_type,
        //       sub_total: data.postAllData.sub_total,
        //       mark_up: data.postAllData.mark_up,
        //       sinking_fund: data.postAllData.sinking_fund,
        //       total_expense: data.postAllData.total_expense,
        //       assetId: data.postAllData.assetId,
        //       assetName: data.postAllData.assetName,
        //       OutflowOpexType: data.otherDetailsArr.OutflowOpexType,
        //       OutflowSubType: data.otherDetailsArr.OutflowSubType,
        //       outflow: data.otherDetailsArr.outflow,
        //     }
        //     this.setState({});
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      }
    }
  }

  valueChange = (newValue, actionMeta) => {
    console.log("newVa calling..", newValue, "meta", actionMeta);

    //newValue.value = newValue.target.value;
    //newValue.label = newValue.target.value;

    if (actionMeta == "change_state") {
      this.state.initialValues.stateId = newValue.value;
      this.state.initialValues.state_name = newValue.label;

      this.state.initialValues.districtId = "";
      this.state.initialValues.districtName = "";
      this.state.initialValues.cityId = "";
      this.state.initialValues.cityName = "";


      this.state.initialValues.assetId = "";
      this.state.initialValues.assetName = "";

      fetch(
        `${apiUrl.apiUrl.url}/district/state-districts?state_id=` +
        newValue.value,
        {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            districtList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      //districtList
    } else if (actionMeta == "change_asset_name") {
      //
      this.state.initialValues.assetId = newValue.value;
      this.state.initialValues.assetName = newValue.label;

    } else if (actionMeta == "change_lease_month") {
      //change_lease_number
      this.state.initialValues.leaseMonthId = newValue.value;
      this.state.initialValues.leaseMonthId = newValue.label;
    }
    this.setState({});
  };

  checkDelete() {
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/outflow/check-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        self.setState({
          messsagePopup: true,
          popupContent: "Sorry you cannot delete this data",
        });
      } else {
        self.setState({
          delete: true,
        });
      }
    });
  }

  redirectToDelete = () => {
    this.setState({ delete: false });
    var ths = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/outflow/delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        ths.setState({
          messsagePopup: true,
          popupContent: "Something Went Wrong",
        });
      } else {
        ths.setState({
          messsagePopup: true,
          popupContent: "Data Deleted Successfully",
        });
      }
    });
  };


  redirectToClose = () => {
    this.setState({ delete: false });
  };

  infoClose = () => {
    this.setState({
      redirect: false,
      messsageInfoPopup: false
    });
  }

  setTotalExpense = () => {
    let sinking_fund = parseFloat(this.state.initialValues.sinking_fund > 0 ? this.state.initialValues.sinking_fund : 0);
    let total = parseFloat(this.state.initialValues.sub_total > 0 ? this.state.initialValues.sub_total : 0);
    let mark_up = parseFloat(this.state.initialValues.mark_up > 0 ? this.state.initialValues.mark_up : 0);

    console.log(total, "==", sinking_fund, "===", mark_up)
    //var total = this.state.initialValues.sub_total;
    this.state.initialValues.total_expense = (total + ((mark_up * total) / 100) + ((sinking_fund * total) / 100)).toFixed(2)
    this.setState({});
  }

  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        groupId: "",
        groupName: "",
        clientId: "",
        clientName: "",
        asset_name: "",
        outflow_type: "",
        financialYearOne: "",
        financialYearTwo: "",
      },
    });
  };

  redirectAfterEdit = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        groupId: "",
        groupName: "",
        clientId: "",
        clientName: "",
        asset_name: "",
        outflow_type: "",
        financialYearOne: "",
        financialYearTwo: "",
      },
    });
  };


  year = () => {
    const arr = [];


    for (let i = 0; i < 10; i++) {
      arr.push(<option>{i}</option>);
    }
    return <div>year</div>
  }

  formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  handleCalenderOnBlur = () => {
    this.state.initialValues.financialYearOne = this.formatDate(
      this.state.financialYearOne
    );
    this.state.initialValues.financialYearTwo = this.formatDate(
      this.state.financialYearTwo
    );
  };
  getAssetsList = (input, e, cust) => {
    if (
      (typeof e != "undefined" && e.action == "input-change") ||
      cust === true
    ) {
      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        this.state.initialValues.cityId +
        `&assetName=` +
        input,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/outflow" />;
    }
    return (
      <>
        <TopHeader />
        <div className="parentContainer">
          {this.renderForm()}
        </div>
      </>
    );
  }

  renderForm() {
    return (
      <>

        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/outflow">Outflow</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="/outflow">Create Outflow Master</Link>
              </li>
            </ul>
          </div>
        </div>


        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {
            // values.assetTypeId = this.state.initialValues.assetTypeId;
            // values.assetId = this.state.initialValues.assetId;
            // values.subAssetId = this.state.initialValues.subAssetId;
            if (this.validator.allValid()) {
              this.validator.hideMessages();
              console.log(values);
              var self = this;
              axios({
                method: "post",
                url: `${apiUrl.apiUrl.url}/outflow/get-asset-wise-data`,
                data: this.state.initialValues,
              }).then(function (response) {
                console.log(response.data.count, "count chekcing");
                if (!response.data.success) {
                  actions.setSubmitting(false);
                  actions.setErrors(response.data);
                } else {
                  if (response.data.count == 0) {
                    self.state.formElements = response.data.formElements
                    self.state.initialValues.OutflowOpexType = response.data.otherDetailsArr.OutflowOpexType;
                    self.state.initialValues.OutflowSubType = response.data.otherDetailsArr.OutflowSubType;
                    self.state.initialValues.outflow = response.data.otherDetailsArr.outflow;
                    self.state.filterShow = false;
                  } else {
                    self.setState({
                      messsageInfoPopup: true,
                      popupInfoContent: "There is already entry exists for this Period ",
                    });
                    self.state.filterShow = true;
                  }

                  self.setState({});
                }
              });
            } else {
              this.validator.showMessages();
            }


          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <div className="padding_left_class">
              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">
                      {clientAccess() && (
                        <div className="newGridSectionInner">
                          <label>
                            Client Group <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="clientGroup"
                              onChange={(e) => {
                                this.handleChangeLandlordGroup(e, "change_client_group");
                              }}
                              value={{
                                label: this.state.initialValues.groupName,
                                value: this.state.initialValues.groupId,
                              }}
                              options={this.state.LandlordGroups.map((item) => ({
                                label: item.group_name,
                                value: item.id,
                              }))}
                            />
                          </div>
                        </div>
                      )}

                      {clientAccess() && (
                        <div className="newGridSectionInner">
                          <label>
                            Client Name <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="clientName"
                              onChange={(e) => {
                                this.handleChangeLandlordGroup(e, "change_client_name");
                              }}
                              value={{
                                label: this.state.initialValues.clientName,
                                value: this.state.initialValues.clientId,
                              }}
                              options={this.state.clientList.map((item) => ({
                                label: item.client_name,
                                value: item.id,
                              }))}
                            />
                            <ErrorMessage name="clientName" component="div" className="text-red" />
                          </div>
                        </div>
                      )}

                      <div className="newGridSectionInner">
                        <label>
                          Outflow Type <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            disabled={this.state.disableFields}
                            as="select"
                            name="outflow_type"
                            onChange={(e) => {
                              this.state.initialValues.outflow_type = e.target.value;
                              this.state.filterShow = true;
                              handleChange(e);
                              this.setState({});
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            <option value="CAM" label="CAM" />
                            <option value="Property Tax" label="Property Tax" />
                            <option value="Insurance" label="Insurance" />
                            <option value="CAPEX" label="CAPEX" />
                          </Field>
                          {this.validator.message('Outflow Type', this.state.initialValues.outflow_type, 'required')}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Asset Name <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            disabled={this.state.disableFields}
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="assetId"
                            onInputChange={this.getAssetsList}
                            onChange={(e) => {
                              this.state.filterShow = true;
                              if (this.state.disableFields === false) {
                                this.valueChange(e, "change_asset_name");
                              }
                            }}
                            value={{
                              label: this.state.initialValues.assetName,
                              value: this.state.initialValues.assetId,
                            }}
                            options={this.state.assetsList.map((item) => ({
                              label: item.asset_name,
                              value: item.id,
                            }))}
                          />
                          {this.validator.message('Asset', this.state.initialValues.assetId, 'required')}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          From Period <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <DatePicker
                            readOnly={this.state.disableFields}
                            onChange={(date) => this.setState({ financialYearOne: date, filterShow: true })}
                            onBlur={this.handleCalenderOnBlur}
                            dateFormat="MMMM yyyy"
                            showMonthYearPicker
                            placeholderText="Month From"
                            selected={this.state.financialYearOne}
                            onCalendarClose={this.handleCalenderOnBlur}
                            maxDate={this.state.financialYearTwo}
                          />
                          {this.validator.message('Start Date', this.state.financialYearOne, 'required')}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          To Period <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <DatePicker
                            readOnly={this.state.disableFields}
                            onChange={(date) => this.setState({ financialYearTwo: date, filterShow: true })}
                            onBlur={this.handleCalenderOnBlur}
                            dateFormat="MMMM yyyy"
                            showMonthYearPicker
                            placeholderText="Month to"
                            selected={this.state.financialYearTwo}
                            onCalendarClose={this.handleCalenderOnBlur}
                            minDate={this.state.financialYearOne}
                          />
                          {this.validator.message('To Date', this.state.financialYearTwo, 'required')}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Bifurcation
                        </label>
                        <div className="position-relative">
                          <Field
                            style={{ width: "fit-content" }}
                            type="checkbox"
                            disabled={this.state.disableFields}
                            value="1"
                            checked={this.state.initialValues.bifurcationStatus}
                            className="sameAs"
                            onChange={(e) => {
                              this.state.filterShow = true;
                              this.state.initialValues.bifurcationStatus = e.target.checked ? true : false;
                              this.setState({});
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {this.props.match.params.id === undefined && this.state.filterShow && (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="update_button"> Create outflow
                        </button>
                      </div>
                    )}
                  </div>
                </Form>
              </div>


              {/* <div className="unitFormContainer bgWhite m-0">
                <Form autoComplete="off" >
                  <div>
                    <div className="row m-0">
                      {clientAccess() && (
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Client Group <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">
                                <Select
                                  className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                  name="clientGroup"
                                  //onInputChange={this.handleChange}
                                  onChange={(e) => {
                                    this.handleChangeLandlordGroup(
                                      e,
                                      "change_client_group"
                                    );
                                  }}
                                  value={{
                                    label: this.state.initialValues.groupName,
                                    value: this.state.initialValues.groupId,
                                  }}
                                  options={this.state.LandlordGroups.map(
                                    (item) => ({
                                      label: item.group_name,
                                      value: item.id,
                                    })
                                  )}
                                />


                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {clientAccess() && (
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Client Name <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-7">
                                <Select
                                  className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                  name="clientName"
                                  onChange={(e) => {
                                    this.handleChangeLandlordGroup(
                                      e,
                                      "change_client_name"
                                    );
                                  }}
                                  value={{
                                    label: this.state.initialValues.clientName,
                                    value: this.state.initialValues.clientId,
                                  }}
                                  options={this.state.clientList.map((item) => ({
                                    label: item.client_name,
                                    value: item.id,
                                  }))}
                                />
                                <ErrorMessage
                                  name="clientName"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Outlfow Type <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                disabled={this.state.disableFields}
                                as="select"
                                name="outflow_type"
                                onChange={(e) => {
                                  this.state.initialValues.outflow_type = e.target.value;
                                  this.state.filterShow = true;
                                  handleChange(e);
                                  this.setState({})
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                <option value="CAM" label="CAM" />
                                <option value="Property Tax" label="Property Tax" />
                                <option value="Insurnace" label="Insurnace" />
                                <option value="CAPEX" label="CAPEX" />
                              </Field>
                              {this.validator.message('Outflow Type', this.state.initialValues.outflow_type, 'required')}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Asset Name <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Select
                                disabled={this.state.disableFields}
                                className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="assetId"
                                onInputChange={this.getAssetsList}
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //this.changeAsset(e);
                                  this.state.filterShow = true;
                                  if (this.state.disableFields == false) {
                                    this.valueChange(e, "change_asset_name");
                                  }

                                }}
                                value={{
                                  label: this.state.initialValues.assetName,
                                  value: this.state.initialValues.assetId,
                                }}
                                options={this.state.assetsList.map((item) => ({
                                  label: item.asset_name,
                                  value: item.id,
                                }))}
                              />

                              {this.validator.message('Asset ', this.state.initialValues.assetId, 'required')}
                            </div>
                          </div>
                        </div>
                      </div>


                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              From Period <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <DatePicker
                                readOnly={this.state.disableFields}
                                onChange={(date) =>
                                  this.setState({ financialYearOne: date, filterShow: true })
                                }
                                onBlur={this.handleCalenderOnBlur}
                                dateFormat="MMMM yyyy"
                                showMonthYearPicker
                                placeholderText="Month From"
                                selected={this.state.financialYearOne}
                                //selected={this.state.initialValues.financialYearOne}
                                onCalendarClose={this.handleCalenderOnBlur}
                                maxDate={this.state.financialYearTwo}
                              />
                              {this.validator.message('Start Date ', this.state.financialYearOne, 'required')}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              To Period <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <DatePicker
                                readOnly={this.state.disableFields}
                                onChange={(date) =>
                                  this.setState({ financialYearTwo: date, filterShow: true })
                                }
                                onBlur={this.handleCalenderOnBlur}
                                dateFormat="MMMM yyyy"
                                showMonthYearPicker
                                placeholderText="Month to"
                                selected={this.state.financialYearTwo}
                                //selected={this.state.initialValues.financialYearOne}
                                onCalendarClose={this.handleCalenderOnBlur}
                                minDate={this.state.financialYearOne}
                              />
                              {this.validator.message('To Date ', this.state.financialYearTwo, 'required')}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Bifurcation
                            </label>
                            <div className="col-sm-7">
                              <Field
                                type="checkbox"
                                disabled={this.state.disableFields}
                                //name="bifurcationStatus"
                                value="1"
                                checked={this.state.initialValues.bifurcationStatus}

                                className="sameAs"
                                onChange={(e) => {
                                  this.state.filterShow = true;
                                  this.state.initialValues.bifurcationStatus = e.target.checked ? true : false;
                                  this.setState({})
                                  //this.handleChange;
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>


                      {this.props.match.params.id === undefined && this.state.filterShow ? (

                        <div className="row">
                          <div className="col-12 col-sm-8 col-md-12">
                            <div className="btnContainer p-0">
                              <div>
                                <button type="submit">
                                  <FontAwesomeIcon icon={faPlus} /> Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : <></>}

                    </div>
                  </div>
                </Form>
                <hr />
              </div> */}
            </div>
          )}
        </Formik>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {
            console.log(values);
            var self = this;

            //this.state.initialValues.formData = values;
            console.log(this.state.initialValues, "intialvalues");
            axios({
              method: "post",
              url: this.state.url, //`${apiUrl.apiUrl.url}/outflow/save-asset-wise-data`,
              data: { 'initialValues': this.state.initialValues, 'values': values },
            }).then(function (response) {
              if (!response.data.success) {
                actions.setSubmitting(false);
                actions.setErrors(response.data);
              } else {
                self.setState({
                  messsagePopup: true,
                  popupContent: "Data Saved Successfully!",
                });
                //self.state.formElements = response.data.formElements
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <div className="padding_left_class mt-3">

              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">
                      {
                        (!this.state.filterShow && this.state.initialValues.bifurcationStatus == 1 && this.state.initialValues.outflow_type == "CAM") && this.state.formElements.map((element, index) => (
                          <div key={index} className="newGridSectionInner">
                            <label>{element.label}</label>
                            {
                              this.state.formElements[index].elements.map((subElement, subIndex) => (
                                <React.Fragment key={subIndex}>
                                  {
                                    subIndex > 0 &&
                                    <label>-</label>
                                  }
                                  <label>{subElement.label}</label>
                                  <div className="position-relative">
                                    {
                                      subElement['type'].length > 0 ?
                                        <select
                                          param={subIndex}
                                          className="basic-single custom-select-style"
                                          classNamePrefix="custom-select-style-inner"
                                          value={this.state.initialValues["OutflowSubType"][element.label][subElement.label] || ""}
                                          name={`OutflowSubType[${element.label}][${subElement.label}]`}
                                          onChange={(e) => {
                                            this.state.initialValues["OutflowSubType"][element.label][subElement.label] = e.target.value;
                                            this.setState({})
                                            handleChange(e);
                                          }}
                                        >
                                          <option value="" label="Select" defaultValue />
                                          {subElement['type'].map((obj) => (
                                            <option key={"companyName" + obj} value={obj}>
                                              {obj}
                                            </option>
                                          ))}
                                        </select>
                                        : '-'
                                    }
                                  </div>
                                  <div className="position-relative">
                                    <select
                                      className="basic-single custom-select-style"
                                      classNamePrefix="custom-select-style-inner"
                                      value={this.state.initialValues["OutflowOpexType"][element.label][subElement.label] || ""}
                                      name={`OutflowOpexType[${element.label}][${subElement.label}]`}
                                      onChange={(e) => {
                                        var id = e.target.getAttribute("param");
                                        console.log(e.target.value, "target")
                                        this.state.initialValues["OutflowOpexType"][element.label][subElement.label] = e.target.value;
                                        this.setState({})
                                        handleChange(e);
                                      }}
                                    >
                                      <option value="" label="Select" />
                                      {["R - Opex", "NR - Opex"].map((obj) => (
                                        <option key={"companyName" + obj} value={obj}>
                                          {obj}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="position-relative">
                                    <Field type="number" name={`outflow[${element.label}][${subElement.label}]`} onBlur={(e) => {
                                      let total = 0;
                                      Object.keys(values.outflow).forEach(function (val, ind) {
                                        Object.keys(values.outflow[val]).forEach(function (subHead, subInd) {
                                          if (values.outflow[val][subHead] > 0) {
                                            total += parseFloat(values.outflow[val][subHead]);
                                          }
                                        })
                                      })
                                      this.state.initialValues.sub_total = total;
                                      this.state.initialValues.total_expense = (total + ((this.state.initialValues.mark_up * total) / 100) + ((this.state.initialValues.sinking_fund * total) / 100)).toFixed(2)
                                      this.setState({});
                                      handleChange(e);
                                    }} />
                                  </div>
                                </React.Fragment>
                              ))
                            }
                          </div>
                        ))
                      }
                      {
                        (!this.state.filterShow && ((this.state.initialValues.outflow_type != "CAM") || (this.state.initialValues.bifurcationStatus == false && this.state.initialValues.outflow_type == "CAM") || (this.state.formElements.length > 0))) &&
                        <>
                          <div className="newGridSectionInner">
                            <label>Sub Total (Per Month)</label>
                            <div className="position-relative">
                              <Field type="number" name='sub_total' value={this.state.initialValues.sub_total} onChange={(e) => {
                                this.state.initialValues.sub_total = e.target.value;
                                let total = e.target.value;
                                this.setTotalExpense();
                                handleChange(e);
                              }} />
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label>Mark Up (%)</label>
                            <div className="position-relative">
                              <Field type="number" name='mark_up' value={this.state.initialValues.mark_up} onChange={(e) => {
                                this.state.initialValues.mark_up = e.target.value;
                                this.setTotalExpense();
                                handleChange(e);
                              }} />
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label>Sinking Fund (%)</label>
                            <div className="position-relative">
                              <Field type="number" name='sinking_fund' value={this.state.initialValues.sinking_fund} onChange={(e) => {
                                this.state.initialValues.sinking_fund = e.target.value;
                                this.setTotalExpense();
                                handleChange(e);
                              }} />
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label>Total Expenses  (Per Month)</label>
                            <div className="position-relative">
                              <Field type="number" name='total_expense' value={this.state.initialValues.total_expense} />
                            </div>
                          </div>
                        </>
                      }
                    </div>
                    {!this.state.filterShow && (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="update_button big_button">
                          Save
                        </button>
                      </div>
                    )}
                  </div>
                </Form>
              </div>


              {/* <div className="unitFormContainer unitFormContainer2 bgWhite ">
                <Form autoComplete="off" >
                  {
                    (!this.state.filterShow &&
                      this.state.initialValues.bifurcationStatus == 1
                      && this.state.initialValues.outflow_type == "CAM")
                    && this.state.formElements.map((element, index) => (
                      <>
                        <div className="row m-0">
                          <div className="col-sm-3">
                            <label>{element.label}</label>
                          </div>
                          {
                            this.state.formElements[index].elements.map((subElement, subIndex) => (
                              <>
                                {
                                  subIndex > 0 &&
                                  <div className="col-sm-3">
                                    <label>-</label>
                                  </div>
                                }
                                <div className="col-sm-3">
                                  <label>{subElement.label}</label>
                                </div>
                                <div className="col-sm-3">

                                  {
                                    subElement['type'].length > 0 ?

                                      <select
                                        param={subIndex}
                                        className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                        value={this.state.initialValues["OutflowSubType"][element.label][subElement.label] || ""}
                                        name={`OutflowSubType[` + element.label + `][` + subElement.label + `]`}
                                        onChange={(e) => {
                                          this.state.initialValues["OutflowSubType"][element.label][subElement.label] = e.target.value;
                                          this.setState({})
                                          handleChange(e);
                                        }}
                                      >
                                        <option value="" label="Select" defaultValue />
                                        {subElement['type'].map((obj) => (
                                          <option key={"companyName" + obj} value={obj}>
                                            {obj}
                                          </option>
                                        ))}
                                      </select>
                                      : '-'
                                  }




                                </div>
                                <div className="col-sm-1">

                                  <select
                                    //param={subIndex}
                                    className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                    value={this.state.initialValues["OutflowOpexType"][element.label][subElement.label] || ""}
                                    name={`OutflowOpexType[` + element.label + `][` + subElement.label + `]`}
                                    onChange={(e) => {
                                      var id = e.target.getAttribute("param");
                                      console.log(e.target.value, "target")
                                      this.state.initialValues["OutflowOpexType"][element.label][subElement.label] = e.target.value;
                                      this.setState({})

                                      handleChange(e);
                                      // this.displayUnitDetails(e, )
                                    }}
                                  >
                                    <option value="" label="Select" />
                                    {["R - Opex", "NR - Opex"].map((obj) => (
                                      <option key={"companyName" + obj} value={obj}>
                                        {obj}
                                      </option>
                                    ))}
                                  </select>


                                </div>
                                <div className="col-sm-2">
                                  <Field type="number" name={`outflow[` + element.label + `][` + subElement.label + `]`} onBlur={(e) => {
                                    let total = 0;
                                    Object.keys(values.outflow).forEach(function (val, ind) {
                                      Object.keys(values.outflow[val]).forEach(function (subHead, subInd) {
                                        if (values.outflow[val][subHead] > 0) {
                                          total += parseFloat(values.outflow[val][subHead]);
                                        }
                                      })
                                    })
                                    this.state.initialValues.sub_total = total;

                                    this.state.initialValues.total_expense = (total + ((this.state.initialValues.mark_up * total) / 100) + ((this.state.initialValues.sinking_fund * total) / 100)).toFixed(2)

                                    this.setState({});
                                    handleChange(e);
                                  }} />
                                </div>
                              </>
                            ))
                          }

                        </div>
                      </>
                    ), this)
                  }
                  {
                    (!this.state.filterShow && ((this.state.initialValues.outflow_type != "CAM") || (this.state.initialValues.bifurcationStatus == false && this.state.initialValues.outflow_type == "CAM") || (this.state.formElements.length > 0))) &&
                    <>
                      <div className="row m-0">
                        <div className="col-sm-3">
                          <label>Sub Total (Per Month)</label>
                        </div>
                        <div className="col-sm-3">
                          <Field type="number" name='sub_total' value={this.state.initialValues.sub_total} onChange={(e) => {
                            this.state.initialValues.sub_total = e.target.value;
                            let total = e.target.value;
                            //this.state.initialValues.total_expense = (total + (( this.state.initialValues.mark_up * total ) / 100) + (( this.state.initialValues.sinking_fund * total ) / 100)).toFixed(2)
                            this.setTotalExpense();
                            handleChange(e);
                          }} />
                        </div>
                      </div>
                      <div className="row m-0">
                        <div className="col-sm-3">
                          <label>Mark Up (%)</label>
                        </div>
                        <div className="col-sm-3">
                          <Field type="number" name='mark_up' value={this.state.initialValues.mark_up} onChange={(e) => {
                            this.state.initialValues.mark_up = e.target.value;
                            this.setTotalExpense();
                            // var total = this.state.initialValues.sub_total;
                            // this.state.initialValues.total_expense = (total + (( this.state.initialValues.mark_up * total ) / 100) + (( this.state.initialValues.sinking_fund * total ) / 100)).toFixed(2)
                            handleChange(e);
                          }} />
                        </div>
                      </div>

                      <div className="row m-0">
                        <div className="col-sm-3">
                          <label>Sinking Fund (%)</label>
                        </div>
                        <div className="col-sm-3">
                          <Field type="number" name='sinking_fund' value={this.state.initialValues.sinking_fund} onChange={(e) => {
                            this.state.initialValues.sinking_fund = e.target.value;
                            this.setTotalExpense();
                            // var total = this.state.initialValues.sub_total;
                            // this.state.initialValues.total_expense = (total + (( this.state.initialValues.mark_up * total ) / 100) + (( this.state.initialValues.sinking_fund * total ) / 100)).toFixed(2)
                            handleChange(e);
                          }} />
                        </div>
                      </div>

                      <div className="row m-0">
                        <div className="col-sm-3">
                          <label>Total Expenses  (Per Month)</label>
                        </div>
                        <div className="col-sm-3">
                          <Field type="number" name='total_expense' value={this.state.initialValues.total_expense} />
                        </div>
                      </div>
                    </>
                  }

                  {!this.state.filterShow && (
                    <div className="row">
                      <div className="col-12 col-sm-8 col-md-12">
                        <div className="btnContainer">
                          <div>
                            <button type="submit">
                              <FontAwesomeIcon icon={faPlus} /> Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                </Form>

              </div> */}
            </div>

          )}
        </Formik>



        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />

        <InfoPopupMessage
          open={this.state.messsageInfoPopup}
          content={this.state.popupInfoContent}
          infoClose={this.infoClose}
          infoOk={this.infoClose}
        />

        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Delete the item?"
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
      </>
    );
  }
}

export default withRouter(OutflowComponentCreate);
